import { render, staticRenderFns } from "./DocumentComments.vue?vue&type=template&id=680007b5&"
import script from "./DocumentComments.vue?vue&type=script&lang=js&"
export * from "./DocumentComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports